interface LoomEmbedProps {
  videoId: string;
  /** The Markdown link's label, when it had one. Names the player for screen readers. */
  title?: string;
}

/**
 * Loom's own player, embedded for a Loom link that an author put on its own
 * line in a Markdown description. The player URL is derived from the share URL
 * rather than fetched, so rendering costs no network call — see
 * `remark-loom-embeds.ts` for how the link is recognized.
 *
 * Unsandboxed on purpose: this is a fixed origin we chose, not user-supplied
 * HTML like the MCP app frames, and Loom's player needs scripts, storage, and
 * fullscreen to work at all. The auth proxy's CSP `frame-src` is what scopes
 * which origins may be framed.
 */
export function LoomEmbed({ videoId, title }: LoomEmbedProps) {
  return (
    // `not-prose` keeps the Tailwind Typography media styles off the frame so
    // this container's own border and radius are what show.
    <div className="not-prose my-4 aspect-video w-full overflow-hidden rounded-lg border border-border">
      <iframe
        src={`https://www.loom.com/embed/${videoId}`}
        title={title ?? "Loom video"}
        loading="lazy"
        allow="fullscreen; picture-in-picture"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="size-full border-0"
      />
    </div>
  );
}
